interface SectionHeaderProps {
  title: string;
  action?: string;
  onAction?: () => void;
  secondaryAction?: string;
  onSecondaryAction?: () => void;
}

export function SectionHeader({
  title,
  action,
  onAction,
  secondaryAction,
  onSecondaryAction,
}: SectionHeaderProps) {
  return (
    <div className="mb-2.5 flex items-center justify-between">
      <h2 className="text-base font-semibold text-foreground">{title}</h2>
      <div className="flex items-center gap-3">
        {secondaryAction && onSecondaryAction && (
          <button
            type="button"
            onClick={onSecondaryAction}
            className="text-[13px] font-medium text-muted-foreground hover:text-foreground"
          >
            {secondaryAction}
          </button>
        )}
        {action && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="text-[13px] font-medium text-primary hover:opacity-80"
          >
            {action}
          </button>
        )}
      </div>
    </div>
  );
}
